<template>
  <v-dialog :persistent="true" max-width="800px" v-model="inDialog">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title style="padding-left: 10px">
          {{ $t(formName)}}
        </v-toolbar-title>
      </v-toolbar>
      <v-btn
          @click="onCancel"
          icon
          style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
      >
        <v-icon>cancel</v-icon>
      </v-btn>
      <v-form @keyup.enter.native="onSave" id="createForm" lazy-validation ref="createForm" v-model="formValid">
        <v-layout wrap>
          <v-flex style="padding: 10px" xs12>
            <v-text-field :data-vv-as="$t('lang.emailConfig.host')" :error-messages="errors.first('host')"
                          :label="$t('lang.emailConfig.host')"
                          name="host"
                          v-model="item['host']"
                          v-validate="'required'"
            />
            <v-text-field :data-vv-as="$t('lang.emailConfig.port')" :error-messages="errors.first('port')"
                          :label="$t('lang.emailConfig.port')"
                          name="port"
                          v-model="item['port']"
                          v-validate="'required'"
            />
            <v-text-field :data-vv-as="$t('lang.emailConfig.email')" :error-messages="errors.first('email')"
                          :label="$t('lang.emailConfig.email')"
                          name="email"
                          v-model="item['email']"
                          v-validate="'required|email'"
            />

            <v-text-field :data-vv-as="$t('lang.emailConfig.password')" :error-messages="errors.first('password')"
                          :label="$t('lang.emailConfig.password')"
                          name="password"
                          type="password"
                          v-model="item['password']"
                          v-validate="item.emailConfigId?'':'required'"
            />

            <v-text-field :data-vv-as="$t('lang.emailConfig.shortName')" :error-messages="errors.first('shortName')"
                          :label="$t('lang.emailConfig.shortName')"
                          name="shortName"
                          v-model="item['shortName']"
                          v-validate="'required'"
            />
            <v-text-field :data-vv-as="$t('lang.emailConfig.color')" :error-messages="errors.first('color')"
                          :label="$t('lang.emailConfig.color')"
                          name="color"
                          v-model="item['color']"
                          v-validate="'required'"
            />
          </v-flex>
          <v-flex style="padding: 10px" xs12>
            <v-autocomplete :data-vv-as="$t('lang.groups.groupName')"
                      :error-messages="errors.first('groupId')"
                      :items="groups"
                      :label="$t('lang.groups.groupName')"
                      item-text="groupName"
                      item-value="groupId"
                      name="groupId"
                      v-model="item['groupId']"
                      v-validate="'required'"

            />
          </v-flex>
          <v-flex style="padding: 10px" xs12>
            <v-checkbox label="Sử dụng SSL" name="useSsl" key="useSsl" v-model="item.useSsl"/>
          </v-flex>

        </v-layout>
      </v-form>
      <div style="text-align: right">
        <v-btn @click="onSave" color="primary">
          <v-icon dark left>save</v-icon>
          {{$t('lang.common.save')}}
        </v-btn>
        <v-btn @click="onCancel" color="error">
          <v-icon dark left>cancel</v-icon>
          {{$t('lang.common.cancel')}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from "axios";
  import {message} from "@/shared/message";

  export default {
    name: 'group-create',
    components: {},
    inheritAttrs: true,
    props: {
      propsItem: {
        type: Object,
        default: null,
      },
      cDialog: {
        type: Boolean,
        default: false,
      },
    },
    data: () => {
      return {
        formName: "Cập nhật Email",
        formValid: false,
        item: {
          status: 1,
          useSsl: true,
        },
        model: {},
        customerTypes: [],
        groups: [],
        inDialog: false,
      }
    },
    watch: {
      propsItem: {
        handler(value) {
          if (value !== null) {
            this.item = Object.assign({}, value)
          } else {
            this.resetFrom();
          }
        },
        deep: true,
      },
      cDialog(value) {
        this.inDialog = value;
      },
      inDialog(value) {
        if (!value) {
          this.$emit("closeDialog", "");
        }
      },
    },
    methods: {
      resetFrom: function () {
        this.item = {
          status: 1,
          useSsl: false,
        };
      },
      onCancel: function () {
        this.$emit("closeDialog", "");
      },
      onSave: function () {
        this.$validator.validate().then(
          valid => {
            if (!valid) {
              message.error(this.$t('lang.common.validate_fail'));
              return;
            }
            // console.log(this.item.useSsl);
            if (this.item.useSsl) {
              this.item.useSsl = 1;
            } else {
              this.item.useSsl = 0;
            }
            axios.post(process.env.VUE_APP_API_URL + "/emailConfig/save", this.item).then(data => {
              if (data.success) {
                message.success(this.$t("lang.common.save_success"));
                this.$emit("save", this.item);
                this.onCancel();
              } else {
                message.error(this.$t(data.description));
              }
            }, error => {
              message.error(error);
            });

          }
        )
      },
    },

    created() {
      axios.post(process.env.VUE_APP_API_URL + "/groups/search?page=-1&pageSize=-1", {}).then(
          data => {
            this.groups = data.items;
          }
      )

    },


  }
</script>
